// extracted by mini-css-extract-plugin
module.exports = {"SingleComment":"SingleComment_SingleComment__3qdLa"};